const ROTJLuke = () => {
	return <h1>Belt - Return of the Jedi, Luke</h1>;
  };
  
  export default ROTJLuke;